export const SEND_CONFIGS = {
  campaign: {
    itemName: "campaign",
    itemLabel: "Campaign ID",
    itemIdField: "campaignid",
    itemDisplayField: "campaignname",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/CampaignOperation/SubUser/GetDistinct/campaignname_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/Campaign",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/Campaign",
    singleTitle: "Send Campaign",
    groupTitle: "Send Campaign to SubGroup",
    singleButtonText: "Send Campaign",
    groupButtonText: "Send Campaign to SubGroup",
  },
  audio: {
    itemName: "audio",
    itemLabel: "Audio ID",
    itemIdField: "audioid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/AudioOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/Audio",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/Audio",
    singleTitle: "Send Audio",
    groupTitle: "Send Audio to SubGroup",
    singleButtonText: "Send Audio",
    groupButtonText: "Send Audio to SubGroup",
  },
  audioPackage: {
    itemName: "audiopack",
    itemLabel: "Audio Package ID",
    itemIdField: "audiopackid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/AudioPackInfoOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/AudioPack",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/AudioPack",
    singleTitle: "Send Audio Package",
    groupTitle: "Send Audio Package to SubGroup",
    singleButtonText: "Send Audio Package",
    groupButtonText: "Send Audio Package to SubGroup",
  },
  catalog: {
    itemName: "catalog",
    itemLabel: "Catalog ID",
    itemIdField: "catalogid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/CatalogOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/Catalog",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/Catalog",
    deleteSingleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/Delete/Catalog",
    deleteAllApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/DeleteAll/Catalog",
    groupDeleteSingleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/Delete/Catalog",
    groupDeleteAllApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/DeleteAll/Catalog",
    singleTitle: "Send Catalogue",
    groupTitle: "Send Catalogue to SubGroup",
    singleButtonText: "Send Catalogue",
    groupButtonText: "Send Catalogue to SubGroup",
  },
  dqrImage: {
    itemName: "dqrimage",
    itemLabel: "DQR Image ID",
    itemIdField: "dqrimageid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/DqrImageOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/DqrImage",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/DqrImage",
    singleTitle: "Send DQR Image",
    groupTitle: "Send DQR Image to SubGroup",
    singleButtonText: "Send DQR Image",
    groupButtonText: "Send DQR Image to SubGroup",
  },
  firmware: {
    itemName: "firmware",
    itemLabel: "Firmware ID",
    itemIdField: "firmwareid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/FirmwareOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/Firmware",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/Firmware",
    singleTitle: "Send Firmware",
    groupTitle: "Send Firmware to SubGroup",
    singleButtonText: "Send Firmware",
    groupButtonText: "Send Firmware to SubGroup",
  },
  htmlDoc: {
    itemName: "htmldoc",
    itemLabel: "HTML Doc ID",
    itemIdField: "htmldocid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/HtmlDocOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/HtmlDoc",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/HtmlDoc",
    singleTitle: "Send HTML Doc",
    groupTitle: "Send HTML Doc to SubGroup",
    singleButtonText: "Send HTML Doc",
    groupButtonText: "Send HTML Doc to SubGroup",
  },
  htmlDocZip: {
    itemName: "htmldoczip",
    itemLabel: "HTML Doc Zip ID",
    itemIdField: "htmldoczipid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/HtmlDocZipOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/HtmlDocZip",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/HtmlDocZip",
    singleTitle: "Send HTML Doc Zip",
    groupTitle: "Send HTML Doc Zip to SubGroup",
    singleButtonText: "Send HTML Doc Zip",
    groupButtonText: "Send HTML Doc Zip to SubGroup",
  },
  mqttSetting: {
    itemName: "mqttsetting",
    itemLabel: "MQTT Setting ID",
    itemIdField: "mqttsettingid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/MqttSettingOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/MqttSetting",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/MqttSetting",
    singleTitle: "Send MQTT Setting",
    groupTitle: "Send MQTT Setting to SubGroup",
    singleButtonText: "Send MQTT Setting",
    groupButtonText: "Send MQTT Setting to SubGroup",
  },
  schedule: {
    itemName: "schedule",
    itemLabel: "Schedule ID",
    itemIdField: "scheduleid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/ScheduleOperation/SubUser/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/Schedule",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/Schedule",
    singleTitle: "Send Schedule",
    groupTitle: "Send Schedule to SubGroup",
    singleButtonText: "Send Schedule",
    groupButtonText: "Send Schedule to SubGroup",
  },
};
